export default "__VITE_ASSET__DR_irwuv__"